module.exports = __webpack_public_path__ + "static/media/codecommit.5fd6f813.png";